module.exports = __webpack_public_path__ + "static/media/Social Desirability.375b8b0b.jpg";